import { render } from "./clientIndex.vue?vue&type=template&id=123f730e&scoped=true"
import script from "./clientIndex.vue?vue&type=script&lang=js"
export * from "./clientIndex.vue?vue&type=script&lang=js"

import "./clientIndex.vue?vue&type=style&index=0&id=123f730e&lang=less&scoped=true"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-123f730e"]])

export default __exports__